// @ utilities
import { APIPost } from 'utilities/APIRequestHelper';
import { getURL } from 'core/apiURLBuilder';
// @ constants
import * as actionTypes from 'constants/actionTypes';

const resetPdfToPrint = () => ({
    type: actionTypes.RESET_PDF_TO_PRINT
});

const fetchPdfToPrintInProgress = () => ({
    type: actionTypes.FETCH_PDF_TO_PRINT_URL_IN_PROGRESS
});

const fetchPdfToPrintSuccess = response => ({
    type: actionTypes.FETCH_PDF_TO_PRINT_URL_SUCCESS,
    payload: {
        response
    }
});

const fetchPdfToPrintFailure = error => ({
    type: actionTypes.FETCH_PDF_TO_PRINT_URL_FAILURE,
    payload: error
});

const fetchPdfToPrint = (documentVariables) => (dispatch) => {
    const request = {
        header: {
            version: 2,
            accept: 'application/pdf',
            responseType: 'arraybuffer',
        },
        query: documentVariables
    }
    dispatch(fetchPdfToPrintInProgress());
    APIPost(dispatch, getURL('requestPreContractualsGenerateURL'), request)
        .then(response => {
            return dispatch(fetchPdfToPrintSuccess(response));

        })
        
        .catch(response => {
            dispatch(fetchPdfToPrintFailure(response.error))
        });
}

module.exports = {
    fetchPdfToPrint,
    resetPdfToPrint
};